module.exports = __webpack_public_path__ + "static/logo-only-blue-1ce455bcee9cda857a62b36e0f77c5b0.png";